module.exports = __webpack_public_path__ + "static/media/alert.ad04d424.ogg";